import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useStyles } from './style';
import Image from 'next/image';
import { Icons } from 'components/Icons';
import { benefitsPricing } from 'utils/benefitsPricing';
import CustomButton from 'components/CustomButton';
import ProfileService from 'services/ProfileService';
import getCleverTap from 'utils/clevertap';
import ReactGA from 'react-ga4';
import usePlan from 'hooks/usePlan';
import { useRouter } from 'next/router';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function CancelSubscriptionModalAlternative({ open, onClose }) {
  const router = useRouter();
  const classes = useStyles();
  const { user } = useAuthUser();
  const profileService = new ProfileService();
  const clevertap = getCleverTap();
  const [plan] = usePlan();

  function sendTrackingEvents() {
    ReactGA.event({
      category: 'my_account',
      action: `cancel_subscription_${plan.billingInterval}`,
      label: 'Click on any creation in My Creations',
      value: user.id,
    });

    clevertap.event.push('Subscription cancelled', {
      Product: 'MTG',
      Email: user.email,
      'Country code': user.country_code,
      URL: router.asPath,
      locale: 'my-account',
      Description: 'Cancel Subscription',
    });
  }

  async function cancelSubscription() {
    sendTrackingEvents();

    switch (plan.gateway) {
      case 'PayPal':
      case 'Paypal': {
        if (user.paypal_id) {
          const subscription = await profileService.cancelPlan();

          router.push('/my-account/billing/cancel-feedback');

          return;
        }
        window.location.href = `${process.env.MTG_URL_LEGACY}/payment/paypal_cancel`;
        return;
      }
      case 'PagarMe': {
        window.location.href = `${process.env.MTG_URL_LEGACY}/payment/cancel`;
        return;
      }
      case 'Stripe':
      case 'Stripe BR': {
        const subscription = await profileService.cancelPlan();

        router.push('/my-account/billing/cancel-feedback');

        return;
      }
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <Box py={6} px={4}>
        <Typography className={classes.title}>Are you sure?</Typography>

        <Typography className={classes.description}>
          If you cancel your subscription now, you will lose access to the following features:
        </Typography>
        <Box display="flex" alignItems="start">
          <Box className={classes.benefitsList}>
            {benefitsPricing.slice(0, 6).map((benefit) => (
              <div key={benefit.id}>
                <Icons.done />
                <p>{benefit.text}</p>
              </div>
            ))}
            <div>
              <Icons.done />
              <p>
                <b>...and much more!</b>
              </p>
            </div>
          </Box>

          <Box pt={1}>
            <Image src="/images/cool-scientist.svg" alt="cool scientist" width={316} height={193} />
          </Box>
        </Box>

        <div className={classes.closeButton}>
          <IconButton onClick={onClose} size="large">
            <Close fontSize="small" />
          </IconButton>
        </div>

        <Box mt={4}>
          <CustomButton
            variant="ctaPinkOutline"
            onClick={cancelSubscription}
            style={{ width: '100%' }}
          >
            Yes, cancel my subscription and lose access to those features
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
}
